import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserConstructionMazeGameProps {
    onComplete: () => void;
}

interface PhaserConstructionMazeGameState {
}

const gameConfig: GameConfig = {
    title: "Construction Maze Game",
    version: "0.2",
    backgroundColor: "#000000",
    physics: {
        default: "matter",
        matter: {
            debug: false,
            gravity: { x: 0, y: 0 }
        }
    },
};

class PhaserConstructionMazeGame extends React.Component<PhaserConstructionMazeGameProps, PhaserConstructionMazeGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserConstructionMazeGameProps) {
        super(props);
        bindAllOfThis(this, PhaserConstructionMazeGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserConstructionMazeGame;



// WEBPACK FOOTER //
// ./src/games/ConstructionMazeGame/Main.tsx